import classNames from "classnames";

import styles from "./CardKleeBanner.module.css";

const CardKleeBanner: React.FC<CardKleeBannerProps> = ({ children, type }) => {
  return (
    <div
      className={classNames(styles.banner, {
        [styles.bannerError]: type === "error",
        [styles.bannerSuccess]: type === "success",
        [styles.bannerWarn]: type === "warn",
        [styles.bannerInfo]: type === "info",
      })}
    >
      {children}
    </div>
  );
};

type CardKleeBannerProps = {
  type: "error" | "success" | "warn" | "info";
};

export default CardKleeBanner;
